import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Package, ChatTeardrop, Gear, House, SignOut } from "@phosphor-icons/react";
import { api } from "../lib/api";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({ products: 0, submissions: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/products", { params: { include_unpublished: true } }),
      api.get("/admin/contact"),
    ]).then(([p, s]) => setStats({ products: p.data.length, submissions: s.data.length })).catch(() => {});
  }, []);

  const onLogout = () => { logout(); navigate("/admin/login"); };

  const navItem = "flex items-center gap-3 px-4 py-3 rounded-2xl text-sm font-semibold transition-colors";
  const active = "bg-[#0F172A] text-white";
  const inactive = "text-slate-700 hover:bg-white/80";

  return (
    <div className="min-h-screen bg-[#FFFBF0]" data-testid="admin-layout">
      <div className="grid lg:grid-cols-[260px_1fr] min-h-screen">
        <aside className="hidden lg:flex flex-col gap-2 p-6 bg-white/60 backdrop-blur border-r border-slate-200">
          <Link to="/" className="font-display font-black tracking-tighter text-lg mb-6">
            HANGANG<span className="text-[#FF6B9E]">.</span>GLOBAL
          </Link>
          <NavLink to="/admin" end data-testid="admin-nav-dashboard" className={({ isActive }) => `${navItem} ${isActive ? active : inactive}`}>
            <House size={18} weight="bold" /> Dashboard
          </NavLink>
          <NavLink to="/admin/products" data-testid="admin-nav-products" className={({ isActive }) => `${navItem} ${isActive ? active : inactive}`}>
            <Package size={18} weight="bold" /> Products
          </NavLink>
          <NavLink to="/admin/submissions" data-testid="admin-nav-submissions" className={({ isActive }) => `${navItem} ${isActive ? active : inactive}`}>
            <ChatTeardrop size={18} weight="bold" /> Submissions
          </NavLink>
          <NavLink to="/admin/settings" data-testid="admin-nav-settings" className={({ isActive }) => `${navItem} ${isActive ? active : inactive}`}>
            <Gear size={18} weight="bold" /> Settings
          </NavLink>
          <div className="mt-auto pt-4 border-t border-slate-200">
            <div className="text-xs text-slate-500 px-4 mb-2">{user?.email}</div>
            <button onClick={onLogout} data-testid="admin-logout" className={`${navItem} text-rose-600 hover:bg-rose-50 w-full text-left`}>
              <SignOut size={18} weight="bold" /> Sign out
            </button>
          </div>
        </aside>

        <main className="p-5 md:p-10">
          <div className="lg:hidden mb-6 flex items-center justify-between">
            <Link to="/" className="font-display font-black tracking-tighter text-lg">
              HANGANG<span className="text-[#FF6B9E]">.</span>GLOBAL
            </Link>
            <button onClick={onLogout} data-testid="admin-logout-mobile" className="sticker">Sign out</button>
          </div>
          <div className="lg:hidden flex gap-2 mb-6 overflow-x-auto pb-2">
            <NavLink to="/admin" end className={({ isActive }) => `sticker whitespace-nowrap ${isActive ? "bg-[#0F172A] text-white border-[#0F172A]" : ""}`}>Dashboard</NavLink>
            <NavLink to="/admin/products" className={({ isActive }) => `sticker whitespace-nowrap ${isActive ? "bg-[#0F172A] text-white border-[#0F172A]" : ""}`}>Products</NavLink>
            <NavLink to="/admin/submissions" className={({ isActive }) => `sticker whitespace-nowrap ${isActive ? "bg-[#0F172A] text-white border-[#0F172A]" : ""}`}>Submissions</NavLink>
            <NavLink to="/admin/settings" className={({ isActive }) => `sticker whitespace-nowrap ${isActive ? "bg-[#0F172A] text-white border-[#0F172A]" : ""}`}>Settings</NavLink>
          </div>
          <Outlet context={{ stats }} />
        </main>
      </div>
    </div>
  );
}
